{
  "error-message-wrapper": {
    "text": {
      "custom": "{{ message }}",
      "email": "Email không hợp lệ",
      "format": "Định dạng sai ({{ correctFormat }})",
      "inRange": "{{ nameOfThisControl }} phải nằm trong khoảng từ {{ min }} đến {{ max }}",
      "notEarlier": "{{ nameOfThisControl }} phải muộn hơn {{ nameOfAnotherControl }}",
      "min": "Giá trị không thể nhỏ hơn {{ min }}",
      "max": "Giá trị không được lớn hơn {{ max }}",
      "minlength": "Giá trị phải có ít nhất {{ requiredLength }} ký tự",
      "maxlength": "Giá trị chỉ được phép có tối đa {{ requiredLength }} ký tự",
      "maxNumberSms": "Đã vượt quá số lượng tối đa {{ max }} SMS",
      "mustContainContent": "{{ nameOfInput }} phải chứa {{ mustContainContent }}",
      "required": "Thông tin này là bắt buộc",
      "sameValue": "Mật khẩu xác nhận không đồng nhất với mật khẩu đã nhập"
    }
  }
}
